import { render, staticRenderFns } from "./RepresentativeWithRecord.vue?vue&type=template&id=20fe157f&scoped=true&lang=pug&"
import script from "./RepresentativeWithRecord.vue?vue&type=script&lang=js&"
export * from "./RepresentativeWithRecord.vue?vue&type=script&lang=js&"
import style0 from "./RepresentativeWithRecord.vue?vue&type=style&index=0&id=20fe157f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fe157f",
  null
  
)

export default component.exports